import React, { Component } from 'react';
import { connect } from 'react-redux';

class CustomDropdown extends Component {
  constructor(props){
    super(props);

    this.state = {
      showDropdown: false,
      list: [
        {
          text: this.props.translations.select_all,
          status: false,
          value: ""
        }
      ],
      origList: [
        {
          text: this.props.translations.select_all,
          status: false,
          value: ""
        }
      ],
      translations: this.props.translations
    }

    this.createList()

  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.translations !== this.props.translations ){
      var list = this.state.list
      var origList = this.state.origList
      list[0].text = nextProps.translations.select_all
      origList[0].text = nextProps.translations.select_all
      this.setState({
        translations: nextProps.translations,
        list: list,
        origList: origList
      })
    }
  }

  createList = () => {
    if (this.props.list){
      let allSelection = true
      this.props.list.map((obj)=>{
        var new_obj = {
          text: (obj.text) ? obj.text : "",
          value: (obj.value) ? obj.value : "",
          status: (obj.status) ? obj.status : false
        }
        allSelection = allSelection && ((obj.status) ? obj.status : false)
        this.state.list = this.state.list.concat(new_obj)
        this.state.origList = this.state.origList.concat(new_obj)
        return true
      })
      this.state.list[0].status = allSelection
      this.setState({
        list: this.state.list,
        origList: this.state.origList
      })
    }
  }

  toggleDropdown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown
    })
  }

  onListClick = (index) => {
    if (index===0){
      this.setAll(!this.state.list[index].status)
    }
    else {
      this.setItem(index)
    }
    this.setState({
      list: this.state.list
    }, ()=>{
      this.callback()
    })
  }

  setItem = (index) => {
    this.state.list[index].status = !this.state.list[index].status;
    var allSelection = true
    this.state.list.map((option, i)=>{
      if (i !== 0){
        allSelection = allSelection && option.status
      }
      return true
    })
    this.state.list[0].status = allSelection
  }

  setAll = (status) => {
    this.state.list.map((obj)=>{
      obj.status = status;
      return true
    })
  }

  callback = () => {
    if (this.props.callback){
      this.props.callback(this.state.list)
    }
  }

  onMouseLeave = (evt) => {
    this.setState({
      showDropdown: false
    })
  }

  render() {
    return (
      <div className={ (this.props.className) ? this.props.className : "custom-dropdown"} onMouseLeave={this.onMouseLeave}>
        <div id="filter-input" onClick={()=>this.toggleDropdown()} ><input type="button" value={this.state.translations.plans_to_compare}/><i className="icon chevron down" ></i></div>
        { this.state.showDropdown &&
          <div id="filter-dropdown">
            <ul>
              { this.state.list.map((obj, index)=>{
                return (
                  <li key={index} onClick={()=>this.onListClick(index)}><input type="checkbox" checked={obj.status}/>&nbsp;&nbsp;{obj.text}</li>
                )
              })
              }
            </ul>
          </div>
        }

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomDropdown);



// WEBPACK FOOTER //
// ./src/components/custom_dropdown.js